// extracted by mini-css-extract-plugin
module.exports = {"SeamlessTransition-detail":"SeamlessTransition_SeamlessTransition-detail__C3JjR"};